import React, { useEffect, useState } from 'react';
import { resetPassword, addData, setData } from '@/actions/auth';
import { useDispatch, useSelector } from 'react-redux';
import { Spin, Input, notification } from 'antd';

const ResetPassword = ({ token }) => {
  useEffect(() => {
    clearState();
  }, []);

  const dispatch = useDispatch();
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const passwordReset = useSelector((state: any) => state?.auth?.resetPassword);

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      token: token,
      password: password,
    };
    if (password === password2) {
      dispatch(resetPassword(data));
    }
  };

  useEffect(() => {
    if (passwordReset?.status) {
      notification.success({ message: 'Password Changed Successfully!' });
      dispatch(
        setData({
          name: 'resetPassword',
          key: 'status',
          value: false,
        })
      );
      window.location.pathname = '/login';
    }
  }, [passwordReset?.status]);

  const clearState = () => {
    dispatch(
      addData({
        key: 'resetPassword',
        value: {},
      })
    );
    dispatch(
      setData({
        name: 'resetPassword',
        key: 'status',
        value: false,
      })
    );
  };

  return (
    <Spin spinning={passwordReset?.loading ? true : false}>
      <div className="main-banner mb-5">
        <div className="d-table">
          <div className="container">
            <div className="col-lg-6 m-auto">
              <div className="banner-form">
                <div className="title">
                  <h3 className="text-primary">Change your Password.</h3>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="otp_code">Password:</label>
                    <Input.Password
                      placeholder="Your Password"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  {passwordReset?.error?.password ? (
                    <span className="validation">
                      <i className="fas fa-exclamation-triangle"></i>{' '}
                      {passwordReset?.error?.password}
                    </span>
                  ) : (
                    ''
                  )}
                  <div className="form-group">
                    <label htmlFor="otp_code">Confirm Password:</label>
                    <Input.Password
                      placeholder="Confirm Password"
                      onChange={(e) => setPassword2(e.target.value)}
                    />
                  </div>
                  {password !== password2 ? (
                    <span className="validation">
                      <i className="fas fa-exclamation-triangle"></i> Passwords Do
                      not Match
                    </span>
                  ) : (
                    ''
                  )}
                  <button type="submit" className="btn btn-primary">
                    Confirm Password
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default ResetPassword;
